import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { useIsWeekToModuleEnabledForCourse } from 'bundles/custom-labels/utils/featureFlags';
import Notification from 'bundles/notification-center/components/Notification';
import type {
  DeadlineOverdueNotification as DeadlineOverdueNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: DeadlineOverdueNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const DeadlineOverdueNotification: React.FC<Props> = ({
  rank,
  notification,
  notification: {
    data: { weekNumber, course, assignments },
  },
  onClick,
}) => {
  let href = '';

  const isWeekToModuleEnabledForCourse = useIsWeekToModuleEnabledForCourse(course.id);

  if (assignments.length === 1) {
    const assignment = assignments[0];
    href = `/learn/${course.slug}/${assignment.typeName}/${assignment.id}`;
  } else if (isWeekToModuleEnabledForCourse) {
    href = `/learn/${course.slug}/home/module/${weekNumber}`;
  } else {
    href = `/learn/${course.slug}/home/week/${weekNumber}`;
  }

  return (
    <Notification href={href} notification={notification} onClick={onClick} rank={rank}>
      <FormattedMessage
        message={_t(
          `{assignmentCount} {assignmentCount, plural, one {assignment} other {assignments}} 
            overdue in {courseName}`
        )}
        assignmentCount={assignments.length}
        courseName={<strong>{course.name}</strong>}
        tagName="span"
      />
    </Notification>
  );
};

export default DeadlineOverdueNotification;
